import type { HTMLAttributes, ReactNode } from 'react';
import classes from './PanelCard.module.css';

interface IPanelCardProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
  /** Suppresses the chrome (background + shadow + padding + radius) so the
   * card can be nested inside an outer shared shell. */
  flush?: boolean;
}

/**
 * Shared panel chrome for analytics report pages. Renders a `<section>` for
 * landmark semantics; consumers pass `aria-label` through `children`/rest.
 * Pass `flush` when the card is nested inside another shared shell that
 * already owns the outer chrome.
 */
export function PanelCard({ children, className, flush, ...rest }: IPanelCardProps) {
  const cls = [
    classes.root,
    flush ? classes.flush : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <section className={cls} {...rest}>
      {children}
    </section>
  );
}
